import { findingError } from "constants/firebaseError";
// import { sendOTP, validateOTP } from "helper/firebase";
import { saveCredential } from "state/credential/credentialSlice";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { Button, Spin } from "antd";
import clsx from "clsx";
import { useEffect, useState } from "react";
import OTPInput from "react-otp-input";

interface InputOTPProps {
  title?: string;
  currentStep?: number;
  onChangeStep?: Function;
  onCancelSendOTP?: Function;
  onAfterSendOTP?: Function;
  hidePhone?: boolean;
}

const SendOTP = (props: InputOTPProps) => {
  const {
    //  "Xác thực OTP"
    title = "Verify OTP",
    onCancelSendOTP,
    onAfterSendOTP,
    hidePhone = false,
  } = props;
  const { initialIdToken } = useAppSelector((state) => state.credential);
  const dispatch = useAppDispatch();

  const {
    verificationId,
    phone,
    // nationCode
  } = useAppSelector((state) => state.credential);

  const [otp, setOTP] = useState("");
  const [allowResend, setAllowResend] = useState(false);
  const [timeToResend, setTimeToResend] = useState(60);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onValidate = async (otp: string, verificationId: string) => {
    if (otp !== "123456") {
      // setErrorMessage("Mã xác thực OTP không hợp lệ");
      setErrorMessage("Invalid OTP verification code");
      return;
    }
    try {
      setLoading(true);
      // const response = await validateOTP(otp, verificationId);
      // const token = await response?.user?.getIdToken();
      setTimeout(() => {
        const token = "verified";
        if (!initialIdToken) {
          dispatch(
            saveCredential({
              initialIdToken: token,
              idToken: token,
            })
          );
        } else {
          dispatch(
            saveCredential({
              idToken: token,
            })
          );
        }
        setLoading(false);
        onAfterSendOTP && onAfterSendOTP(token);
      }, 300);
    } catch (error: any) {
      let findError = findingError(error);
      setErrorMessage(findError.message);
      setLoading(false);
    }
  };

  const handleChange = async (otp: string) => {
    setOTP(otp);
    if (otp.length === 6 && verificationId) {
      onValidate(otp, verificationId);
    }
  };

  const handleResendOTP = () => {
    // phone && nationCode && sendOTP(phone, nationCode);
    setAllowResend(false);
  };

  useEffect(() => {
    if (!allowResend) {
      const intervalId = setInterval(() => {
        if (timeToResend === 1) {
          clearInterval(intervalId);
          setAllowResend(true);
          setTimeToResend(60);
        } else {
          setTimeToResend((timeToResend) => timeToResend - 1);
        }
      }, 1000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [timeToResend, allowResend]);

  return (
    <>
      <h4 className="text-md lg:text-xl font-bold text-center mb-5">{title}</h4>
      <h4 className="text-sm mb-5 lg:mb-8 text-center">
        {/* Vui lòng nhập <span className="font-bold">mã xác thực OTP</span> được
        gửi đến số điện thoại{" "} */}
        Please enter the{" "}
        <span className="font-bold">OTP verification code</span> sent to your
        phone number{" "}
        <span className="font-bold">
          {hidePhone ? "******" + phone?.slice(-4) : phone}
        </span>
      </h4>
      {loading ? (
        <Spin spinning size="large" className="my-4" />
      ) : (
        <>
          <div className="flex flex-col items-start">
            <OTPInput
              inputType="number"
              value={otp}
              onChange={handleChange}
              numInputs={6}
              renderSeparator={<div className="mx-1 lg:mx-5"></div>}
              renderInput={(props) => (
                <input
                  {...props}
                  className={clsx(
                    "input-no-spin !w-[40px] !h-[40px] !outline-none p-3 rounded-lg !border-[1px] !border-solid text-center !text-md md:!text-sm !border-[#C5C6CC] focus:!border-dark",
                    {
                      "!border-danger": errorMessage,
                    }
                  )}
                />
              )}
            />
            {errorMessage && (
              <p className="mt-2 text-danger text-xs">{errorMessage}</p>
            )}
            <div className="flex items-center justify-between w-full mt-4">
              <p
                className={clsx(
                  "btn-link btn-link--no-line btn-link--no-transparent text-xs text-dark hover:font-semibold",
                  {
                    "pointer-events-none !opacity-30": !allowResend,
                    "cursor-pointer !opacity-100": allowResend,
                  }
                )}
                onClick={handleResendOTP}
              >
                {/* Gửi lại OTP */}
                Resend OTP
              </p>
              {!allowResend && timeToResend !== 0 && (
                <p className="text-xs">
                  {/* Mã OTP sẽ hết hiệu lực sau{" "}
                  <span className="font-semibold text-danger">
                    {timeToResend}
                  </span>{" "}
                  giây */}
                  The OTP will expire in{" "}
                  <span className="font-semibold text-danger">
                    {timeToResend}
                  </span>{" "}
                  seconds
                </p>
              )}
            </div>
            <div className="self-stretch flex mt-4">
              <Button
                onClick={() => {
                  onCancelSendOTP && onCancelSendOTP();
                }}
                className="btn btn-outline btn-outline-dark px-4 py-2 mr-2 flex-1"
              >
                {/* Huỷ */}
                Cancel
              </Button>
              <Button
                disabled={otp.length !== 6 || !verificationId}
                onClick={() => {
                  verificationId && onValidate(otp, verificationId);
                }}
                className="btn btn-primary px-4 py-2 ml-2 flex-1"
              >
                {/* Xác nhận */}
                Confirm
              </Button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SendOTP;
